(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const strings = JSON.parse($('#CVStrings')?.textContent || '{}');
  const root = window.Shopify?.routes?.root || '/';
  const openers = new WeakMap();
  let cartBusy = false;


  const cartTimerKey = 'aftrbody:cart-reservation:deadline:v1';
  let cartTimerDeadline = null;
  const renderCartTimers = () => {
    const remaining = cartTimerDeadline === null ? null : Math.max(0, Math.ceil((cartTimerDeadline - Date.now()) / 1000));
    $$('[data-cv-cart-timer]').forEach(node => {
      node.hidden = remaining === null;
      if (remaining === null) return;
      $('[data-cv-timer-clock]', node).textContent = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
      $('[data-cv-timer-label]', node).textContent = remaining > 0 ? node.dataset.cvActiveLabel : node.dataset.cvExpiredLabel;
      node.classList.toggle('is-expired', remaining === 0);
    });
  };
  const initCartTimers = () => {
    const itemCount = Number($('[data-cv-cart-shell]')?.dataset.cvItemCount) || 0;
    try {
      if (itemCount === 0) {
        localStorage.removeItem(cartTimerKey);
        cartTimerDeadline = null;
      } else {
        const saved = Number(localStorage.getItem(cartTimerKey));
        cartTimerDeadline = Number.isFinite(saved) && saved > 0 ? saved : null;
        const visible = $$('[data-cv-cart-timer]').some(node => !node.closest('dialog') || node.closest('dialog').open);
        if (cartTimerDeadline === null && visible) {
          cartTimerDeadline = Date.now() + 10 * 60 * 1000;
          localStorage.setItem(cartTimerKey, String(cartTimerDeadline));
        }
      }
    } catch {
      cartTimerDeadline = null;
    }
    renderCartTimers();
  };
  window.addEventListener('storage', event => {
    if (event.key !== cartTimerKey && event.key !== null) return;
    const saved = Number(event.newValue);
    cartTimerDeadline = Number.isFinite(saved) && saved > 0 ? saved : null;
    renderCartTimers();
  });
  window.setInterval(renderCartTimers, 1000);

  const announce = message => { const status = $('#LiveStatus'); if (status) status.textContent = message; };
  const openDialog = (dialog, opener) => {
    if (!dialog || dialog.open) return;
    openers.set(dialog, opener || document.activeElement);
    dialog.showModal();
    if (dialog.id === 'CVCart') initCartTimers();
    opener?.setAttribute('aria-expanded', 'true');
  };
  const countCart = count => $$('[data-cv-count]').forEach(node => { node.textContent = String(count); node.hidden = count === 0; });
  const cartError = message => { const status = $('[data-cv-cart-status]', $('#CVCart') || document); if (status) status.textContent = message; announce(message); };
  const refreshCart = async () => {
    const shell = $('[data-cv-cart-shell]');
    if (!shell) throw new Error(strings.cartError);
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', shell.dataset.cvSection);
    url.searchParams.set('_cv', String(Date.now()));
    const response = await fetch(url, { cache: 'no-store', headers: { 'Accept': 'text/html' } });
    if (!response.ok) throw new Error(strings.cartError);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const content = $('[data-cv-cart-content]', html);
    const newShell = $('[data-cv-cart-shell]', html);
    if (!content || !newShell) throw new Error(strings.cartError);
    $('[data-cv-cart-content]', shell).replaceChildren(...content.childNodes);
    const title = $('#CVCartTitle', html);
    if (title) $('#CVCartTitle', shell).innerHTML = title.innerHTML;
    shell.dataset.cvItemCount = newShell.dataset.cvItemCount;
    countCart(Number(newShell.dataset.cvItemCount) || 0);
    initCartTimers();
  };
  const changeCart = async (line, quantity) => {
    if (cartBusy) return;
    cartBusy = true;
    const current = $('#CVCart');
    current?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: Number(line), quantity }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || strings.cartError);
      countCart(result.item_count);
      await refreshCart();
      announce(strings.cartSaved);
    } catch (error) { cartError(error.message || strings.cartError); }
    finally { cartBusy = false; current?.removeAttribute('aria-busy'); }
  };
  const showImage = (gallery, button) => {
    if (!gallery || !button) return;
    const image = new Image();
    image.src = button.dataset.cvImage;
    image.alt = button.dataset.cvImageAlt || '';
    image.width = Number(button.dataset.cvImageWidth) || 1200;
    image.height = Number(button.dataset.cvImageHeight) || 1500;
    image.decoding = 'async';
    $('[data-cv-featured]', gallery).replaceChildren(image);
    const buttons = $$('[data-cv-image]', gallery);
    buttons.forEach(node => node.setAttribute('aria-pressed', String(node === button)));
    const counter = $('[data-cv-gallery-count]', gallery);
    if (counter) counter.textContent = `${buttons.indexOf(button) + 1} / ${buttons.length}`;
  };
  const moveImage = (gallery, direction) => {
    const buttons = $$('[data-cv-image]', gallery);
    if (!buttons.length) return;
    const index = Math.max(0, buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
    showImage(gallery, buttons[(index + direction + buttons.length) % buttons.length]);
  };
  document.addEventListener('click', async event => {
    const opener = event.target.closest('[data-cv-open]');
    if (opener) openDialog(document.getElementById(opener.dataset.cvOpen), opener);
    const closer = event.target.closest('[data-cv-close]');
    if (closer) closer.closest('dialog')?.close();
    const dialog = event.target.closest('dialog');
    if (dialog && event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
    const cartOpener = event.target.closest('[data-cv-cart-open]');
    if (cartOpener) {
      event.preventDefault();
      openDialog($('#CVCart'), cartOpener);
      try { await refreshCart(); } catch (error) { cartError(error.message); }
    }
    const quantity = event.target.closest('[data-cv-quantity]');
    if (quantity) {
      const input = $('input[name="quantity"]', quantity.closest('.cv-quantity'));
      const min = Number(input.min) || 1;
      const max = input.max ? Number(input.max) : Infinity;
      input.value = String(Math.min(max, Math.max(min, (Number(input.value) || min) + Number(quantity.dataset.cvQuantity) * (Number(input.step) || 1))));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const thumb = event.target.closest('[data-cv-image]');
    if (thumb) showImage(thumb.closest('[data-cv-gallery]'), thumb);
    const galleryStep = event.target.closest('[data-cv-gallery-step]');
    if (galleryStep) moveImage(galleryStep.closest('[data-cv-gallery]'), Number(galleryStep.dataset.cvGalleryStep));
    const cartStep = event.target.closest('[data-cv-cart-step]');
    if (cartStep) {
      const input = $('input', cartStep.closest('.cv-cart-quantity-control'));
      const increment = Number(input.step) || 1;
      const min = Number(input.min) || 1;
      const max = input.max ? Number(input.max) : Infinity;
      const target = Math.min(max, Math.max(min, Number(input.value) + Number(cartStep.dataset.cvCartStep) * increment));
      if (cartStep.closest('#CVCart')) await changeCart(cartStep.dataset.cvLine, target);
      else { input.value = String(target); announce(strings.cartPending); }
    }
    const remove = event.target.closest('[data-cv-cart-remove]');
    if (remove?.closest('#CVCart')) { event.preventDefault(); await changeCart(remove.dataset.cvLine, 0); }
    const filter = event.target.closest('[data-cv-filter]');
    if (filter) {
      event.preventDefault();
      applyFilter(filter.dataset.cvFilter);
      const url = new URL(window.location.href);
      if (filter.dataset.cvFilter === 'all') url.searchParams.delete('aftr'); else url.searchParams.set('aftr', filter.dataset.cvFilter);
      window.history.replaceState({}, '', url);
    }
  });
  document.addEventListener('close', event => {
    if (!(event.target instanceof HTMLDialogElement)) return;
    const opener = openers.get(event.target);
    opener?.setAttribute('aria-expanded', 'false');
    if (opener?.isConnected) opener.focus();
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-cv-add]');
    if (!form) return;
    event.preventDefault();
    const product = form.closest('[data-cv-product]');
    if (form.dataset.busy) return;
    form.dataset.busy = 'true';
    const buttons = $$('[data-cv-add-button]', product);
    const status = $('[data-cv-product-status]', product);
    const labels = buttons.map(button => button.innerHTML);
    buttons.forEach(button => { button.disabled = true; button.textContent = strings.adding; });
    if (status) status.textContent = '';
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || strings.addError);
      if (status) status.textContent = strings.added;
      announce(strings.added);
      try {
        await refreshCart();
        openDialog($('#CVCart'), event.submitter || buttons[0]);
      } catch (error) {
        window.location.assign(root + 'cart');
      }
    } catch (error) { if (status) status.textContent = error.message || strings.addError; announce(error.message || strings.addError); }
    finally {
      buttons.forEach((button, index) => { button.disabled = false; button.innerHTML = labels[index]; });
      delete form.dataset.busy;
    }
  });
  document.addEventListener('change', async event => {
    const quantity = event.target.closest('[data-cv-cart-quantity]');
    if (quantity?.closest('#CVCart')) {
      if (!quantity.checkValidity()) { quantity.reportValidity(); return; }
      await changeCart(quantity.dataset.cvLine, Number(quantity.value));
    }
    if (event.target.matches('[data-cv-sort]')) {
      const url = new URL(window.location.href); url.searchParams.set('sort_by', event.target.value); window.location.assign(url);
    }
    if (!event.target.matches('[data-cv-variant]')) return;
    const product = event.target.closest('[data-cv-product]');
    const variants = JSON.parse($('[data-cv-variants]', product).textContent);
    const variant = variants.find(item => String(item.id) === event.target.value);
    if (!variant) return;
    $$('[data-cv-price]', product).forEach(node => { node.textContent = variant.price; });
    $$('[data-cv-add-button]', product).forEach(button => { button.disabled = !variant.available; button.textContent = variant.available ? strings.add : strings.soldOut; });
    const quantityInput = $('input[name="quantity"]', product);
    if (quantityInput && variant.quantity_rule) {
      quantityInput.min = variant.quantity_rule.min || 1;
      quantityInput.step = variant.quantity_rule.increment || 1;
      quantityInput.max = variant.quantity_rule.max || '';
      quantityInput.value = quantityInput.min;
    }
    if (variant.image) {
      const image = new Image(); image.src = variant.image; image.alt = $('h1', product).textContent; image.width = 1200; image.height = 1500;
      $('[data-cv-featured]', product).replaceChildren(image);
    }
    const url = new URL(window.location.href); url.searchParams.set('variant', String(variant.id)); window.history.replaceState({}, '', url);
  });
  const applyFilter = group => {
    if (!['all', 'body', 'face', 'eyes', 'sets'].includes(group)) group = 'all';
    const items = $$('[data-cv-product-group]');
    if (!items.length) return;
    let count = 0;
    items.forEach(item => { const visible = group === 'all' || item.dataset.cvProductGroup.split(' ').includes(group); item.hidden = !visible; if (visible) count++; });
    $$('[data-cv-filter]').forEach(link => { if (link.dataset.cvFilter === group) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current'); });
    const label = $('[data-cv-collection-count]');
    if (label) { if (!label.dataset.suffix) label.dataset.suffix = label.textContent.replace(/^\s*\d+/, ''); label.textContent = String(count) + label.dataset.suffix; }
  };
  const init = () => {
    initCartTimers();
    applyFilter(new URL(window.location.href).searchParams.get('aftr') || 'all');
    $$('[data-cv-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      gallery.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); moveImage(gallery, event.key === 'ArrowRight' ? 1 : -1);
      });
      const frame = $('[data-cv-featured]', gallery);
      let touch;
      frame?.addEventListener('touchstart', event => { touch = event.touches.length === 1 ? [event.touches[0].clientX, event.touches[0].clientY] : null; }, { passive: true });
      frame?.addEventListener('touchend', event => {
        if (!touch || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - touch[0];
        const dy = event.changedTouches[0].clientY - touch[1]; touch = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) moveImage(gallery, dx < 0 ? 1 : -1);
      }, { passive: true });
      frame?.addEventListener('touchcancel', () => { touch = null; }, { passive: true });
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
